let _lastKitchenStatus = null;

export async function getMenuItems() {
  const response = await fetch("/api/v1/fnb_menu_items", {
    headers: { Accept: "application/json" },
  });
  const payload = await response.json();
  const categories = payload?.data?.categories || [];
  _lastKitchenStatus = payload?.data?.kitchen_status || null;

  return categories.flatMap((category) =>
    (category.items || []).map((item) => ({
      id: item.id,
      name: item.name,
      category: category.name,
      price: {
        amount: Number(item?.price?.amount || 0),
        formattedText: item?.price?.formatted_text || "",
      },
      description: item.description || "",
      stock: Number(item.stock || 0),
      image: item.image_url,
      orderableType: "FnbMenuItem",
    })),
  );
}

export async function getItemsByCategory(category) {
  const menuItems = await getMenuItems();
  return menuItems.filter((item) => item.category === category);
}

export async function getCategories() {
  const menuItems = await getMenuItems();
  const categories = [...new Set(menuItems.map((item) => item.category))];
  return categories;
}

export async function getKitchenStatus() {
  if (_lastKitchenStatus) {
    const cached = _lastKitchenStatus;
    _lastKitchenStatus = null;
    return cached;
  }
  const response = await fetch("/api/v1/kitchen_status", {
    headers: { Accept: "application/json" },
  });
  const payload = await response.json();
  return payload?.data || null;
}
